import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router'

import isEmpty from 'lodash/isEmpty'
import { Grid, Icon } from 'semantic-ui-react'
import { compose } from 'recompose'

import Enhancer from './UserDetailModuleHOC'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'
import { withPermissions } from 'Components/Permissions'

import PageHeaderRow from 'Components/PageHeaderRow'
import UserCard from 'Components/UserCard'

import * as styles from './styles'

class UserDetailModule extends Component {
  static propTypes = {
    addGroup: PropTypes.func.isRequired,
    changeEmail: PropTypes.func.isRequired,
    changeFirstName: PropTypes.func.isRequired,
    changeLastName: PropTypes.func.isRequired,
    detailUser: PropTypes.object.isRequired,
    error: PropTypes.bool.isRequired,
    groupsOptions: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
    pending: PropTypes.bool.isRequired,
    removeGroup: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
  }

  addGroup = group => {
    const { addGroup, detailUser } = this.props

    addGroup(detailUser.id, group)
  }

  changeEmail = email => {
    const { changeEmail, detailUser } = this.props

    changeEmail(detailUser.id, email)
  }

  changeFirstName = firstName => {
    const { changeFirstName, detailUser } = this.props

    changeFirstName(detailUser.id, firstName)
  }

  changeLastName = lastName => {
    const { changeLastName, detailUser } = this.props

    changeLastName(detailUser.id, lastName)
  }

  removeGroup = group => {
    const { detailUser, removeGroup } = this.props

    removeGroup(detailUser.id, group)
  }

  resetPassword = () => {
    const { detailUser, resetPassword } = this.props

    resetPassword(detailUser.id)
  }

  render() {
    const { detailUser, error, groupsOptions, pending } = this.props
    const { fromPage } = this.props.location.query

    return (
      <Grid>
        <PageHeaderRow title="User Details">
          <Link to={fromPage ? `/${fromPage}` : '/'} style={styles.link}>
            <Icon name="arrow left" />
            Back
          </Link>
        </PageHeaderRow>

        <Grid.Row>
          <Grid.Column width={6}>
            {!isEmpty(detailUser) && (
              <UserCard
                addGroup={this.addGroup}
                changeEmail={this.changeEmail}
                changeFirstName={this.changeFirstName}
                changeLastName={this.changeLastName}
                error={error}
                groupsOptions={groupsOptions}
                pending={pending}
                removeGroup={this.removeGroup}
                resetPassword={this.resetPassword}
                user={detailUser}
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}
const composed = compose(
  withPermissions('modules.users'),
  Enhancer,
  StandardLoader('Calling user…'),
  StandardError,
)

export default composed(UserDetailModule)
